export default __webpack_public_path__ + "assets/icons/icon-tick16-white.01a1077d7f601f5f96829a811cf4167f.svg";